import { assign, findIndex } from 'lodash';
import createReducer from './baseReducer';

const update = (field, state, error, data, id) => {
  let newNotes = [...state[field]];
  if (error === false && data) {
    const index = findIndex(state[field], { id });
    if (index !== -1) {
      newNotes.splice(index, 1, data);
    } else {
      newNotes = [...state[field], data];
    }
  }
  return newNotes;
};

const conditions = {
  REQUEST_ASSIGN_NOTE: state =>
    assign({}, state, {
      isFetching: true,
      error: false,
      didInvalidate: false,
    }),
  REQUEST_UNASSIGN_NOTE: state =>
    assign({}, state, {
      isFetching: true,
      error: false,
      didInvalidate: false,
    }),
  RECEIVE_ASSIGN_NOTE: (state, data, error) => {
    const newState = assign({}, state, {
      error,
      isFetching: false,
      didInvalidate: error !== false,
    });

    const index = findIndex(newState.assignedUsers, {
      id: data.id,
      user_id: data.user_id,
    });

    if (index !== -1) {
      newState.assignedUsers.splice(index, 1, data);
    } else {
      newState.assignedUsers = [...newState.assignedUsers, data];
    }

    return newState;
  },
  RECEIVE_UNASSIGN_NOTE: (state, data, error) => {
    const newState = assign({}, state, {
      error,
      isFetching: false,
      didInvalidate: error !== false,
    });

    const index = findIndex(newState.assignedUsers, {
      id: data.id,
      user_id: data.user_id,
    });

    if (index !== -1) {
      newState.assignedUsers.splice(index, 1);
    }

    return newState;
  },
  REQUEST_GET_NOTES_ASSIGNED_USERS: state =>
    assign({}, state, {
      isFetching: true,
      didInvalidate: false,
      error: false,
      assignedUsers: [],
    }),
  RECEIVE_GET_NOTES_ASSIGNED_USERS: (state, data, error) =>
    assign({}, state, {
      error,
      isFetching: false,
      didInvalidate: error !== false,
      assignedUsers: data,
    }),
  REQUEST_NOTES_ALL: state =>
    assign({}, state, {
      isFetching: true,
      didInvalidate: false,
      allNotes: [],
      error: false,
    }),
  RECEIVE_NOTES_ALL: (state, data, error) =>
    assign({}, state, {
      error,
      isFetching: false,
      didInvalidate: error !== false,
      allNotes: data,
    }),
  RECEIVE_UPDATE_NOTE: (state, data, error, id) => {
    const newNotes = update('notes', state, error, data, id);
    const newAllNotes = update('allNotes', state, error, data, id);
    return assign({}, state, {
      error,
      isFetching: false,
      didInvalidate: error !== false,
      notes: newNotes,
      allNotes: newAllNotes,
    });
  },
};

const state = {
  assignedUsers: [],
  allNotes: [],
};

export default createReducer('notes', 'note', 'notes', conditions, state);
